import { useSearchPageDataContext } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/ViewState/SearchPageDataContext";

export const useSearchPageIsRsc = () => {
  const { rscPageLoadKey } = useSearchPageDataContext();
  return rscPageLoadKey !== "";
};
